export default __webpack_public_path__ + "static/media/cm-roadmap.e93b3dab.png";